import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const SvgCheckbox = ({ width = 16, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Master"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Travel---Hotel-Search-Results---Rating-Filter"
          transform="translate(-382.000000, -328.000000)"
          stroke="#C6C8CC"
        >
          <g
            id="rating---filter"
            transform="translate(358.000000, 243.000000)"
          >
            <g
              id="Group-2"
              transform="translate(24.000000, 84.000000)"
            >
              <g
                id="Group"
                transform="translate(0.000000, 1.000000)"
              >
                <rect
                  id="Rectangle-13"
                  x="0.5"
                  y="0.5"
                  width="15"
                  height="15"
                ></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgCheckbox;
